var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-2" },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text pl-5 pr-3",
                              attrs: {
                                loading: _vm.getingcache,
                                color: "green",
                                elevation: "0",
                              },
                              on: { click: _vm.onGetAssetCacheInfo },
                            },
                            [
                              _vm._v(" get Asset Cache Info "),
                              _c("v-icon", { staticClass: "ml-2" }, [
                                _vm._v("mdi-cloud-download"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text pl-5 pr-3",
                              attrs: {
                                loading: _vm.caching,
                                color: "orange",
                                elevation: "0",
                              },
                              on: { click: _vm.onPressCacheAssets },
                            },
                            [
                              _vm._v(" cache Assets "),
                              _c("v-icon", { staticClass: "ml-2" }, [
                                _vm._v("mdi-refresh"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { width: "100%", elevation: "0" },
                    },
                    [
                      _vm.jsonData != null
                        ? _c("json-viewer", {
                            attrs: {
                              "expand-depth": 10,
                              copyable: "",
                              value: _vm.jsonData,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }